{
  "pt": {
    "locale_field": {
      "fallback_tooltip": "Quando nenhum texto for inserido para este idioma, este texto padrão será usado como substituto."
    }
  }
}
